
class ImageVideoBanner extends HTMLElement {
    constructor() {
      super();
      this.initEvents();
      if (this.querySelector('video')) {
        this.initVideo();
      }
    }

    initVideo() {
      window.addEventListener('DOMContentLoaded', function () {
        let mediaQueries = {
          mediumDown: window.matchMedia('(max-width: 939px)'),
          largeUp: window.matchMedia('(min-width: 940px)'),
        };

        let vidSrc = document.querySelector('#hero-video').dataset.lazySrc;

        function startVideo(pSource) {
          document.querySelector('#hero-video').querySelector('[type="video/mp4"]').src = pSource;
          document.querySelector('#hero-video').load();

          setTimeout(function () {
            document.querySelector('#hero-video').classList.add('is-loaded');
            document.querySelector('#hero-video').play();
          }, 500);
        }

        startVideo(vidSrc);
      });
    }

    initEvents() {
      function smoothScrollToSection(pElementId, pOffsetPixels) {
        // Find the target section element by its ID
        const targetSection = document.getElementById(pElementId);
        // Check if the target section exists
        if (targetSection) {
          // Get the final scroll position
          const scrollPosition = targetSection.offsetTop;
          // Scroll to the target section with smooth behavior
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
          });
        }
      }
    }

  }

  customElements.define('image-video-banner', ImageVideoBanner);